import Vue from "vue";
import Vuelidate from "vuelidate";
import "./plugins/bootstrap-vue";
import "./plugins/bootstrap-vue";
import App from "./App.vue";
import router from "./router";
import { installVersionCheck } from "./utils/versionCheck";
import store from "./store";
import vuetify from "./plugins/vuetify";
import "./assets/css/main.css";

import { BootstrapVue, BootstrapVueIcons } from "bootstrap-vue";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
Vue.use(VueSweetalert2);
import VueBlobJsonCsv from "vue-blob-json-csv";

import VueDropify from "vue-dropify";

import DownloadData from "v-download";
import VueExcelXlsx from "vue-excel-xlsx";
//  PrimeVue Components

const options = {
  name: "_blank",
  specs: ["fullscreen=yes", "titlebar=yes", "scrollbars=yes"],
  styles: [
    "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
    "https://unpkg.com/kidlat-css/css/kidlat.css",
  ],
};

import VueObserveVisibility from "vue-observe-visibility"
Vue.use(VueObserveVisibility);
Vue.component("vue-dropify", VueDropify);

import VueHtmlToPaper from "vue-html-to-paper";

Vue.config.productionTip = false;
installVersionCheck(router);
Vue.use(VueExcelXlsx);
Vue.use(DownloadData);
Vue.use(VueBlobJsonCsv);
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);

Vue.use(Vuelidate);
Vue.use(VueHtmlToPaper, options);
new Vue({
  router,
  store,
  vuetify,
  BootstrapVue,
  BootstrapVueIcons,
  render: (h) => h(App),
}).$mount("#app");
